import { render, staticRenderFns } from "./GroupStatistic.vue?vue&type=template&id=60581466&scoped=true"
import script from "./GroupStatistic.vue?vue&type=script&lang=js"
export * from "./GroupStatistic.vue?vue&type=script&lang=js"
import style0 from "./GroupStatistic.vue?vue&type=style&index=0&id=60581466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60581466",
  null
  
)

export default component.exports